import {
  INCREMENT_TUTORIAL,
  SET_TUTORIAL,
  REGISTER_STEP,
  UNREGISTER_STEP,
} from '../constants/actionTypes'

export const incrementTutorial = () => ({
  type: INCREMENT_TUTORIAL,
})

export const setTutorial = tutorial => ({
  type: SET_TUTORIAL,
  tutorial,
})

export const registerStep = step => ({
  type: REGISTER_STEP,
  step,
})

export const unregisterStep = step => ({
  type: UNREGISTER_STEP,
  step,
})
